import React, { Fragment } from "react";
import styled from "styled-components";
import { colors, font, spacing } from "../theme";
import BookmarkButton from "../bookmarks/BookmarkButton";
import { ApiResult } from "../../lib/CmsApi";
import TopBox from "../common/TopBox";
import { RouteName, RouteParams } from "../../lib/routes";
import DefaultSectionListWithNav, {
  flattenCMSSectionLists
} from "../sections/SectionListWithNav";
import { slug } from "../../lib/formatters";
import {
  StickyNav,
  extractLinksFromSections
} from "../sections/SectionListWithNav/StickyNav";
import { DEFAULT_PADDING } from "../common/Content";
import CustomPageHead from "../common/CustomPageHead";
import FundingStoriesSection from "../sections/FundingStories";
import DownloadSection from "../sections/Downloads";

const SectionListWithNav = styled(DefaultSectionListWithNav)`
  .richtext > h1:first-child {
    margin: 0 0 1.7em 0;
  }
  section {
    &:not(:last-child) {
      padding-bottom: 0 !important;
      ${spacing("margin-bottom", 48)}
    }
    &:last-child {
      ${spacing("margin-bottom", 120)}
    }
  }
`;

const StyledTopBox = styled(TopBox)``;
const StyledBookmarkButton = styled(BookmarkButton)`
  ${spacing("margin-bottom", 64)};
`;

const Navigable = styled.div`
  position: relative;
`;

export type Props = ApiResult<"listNachhaltigkeitArticles"> & {
  url: string;
  pageContents?: ApiResult<"loadNachhaltigkeitArticle">;
  breadCrumpPath: { route: RouteName; params?: RouteParams; title: string }[];
};

export default function NachhaltigkeitPage(props) {
  const cmsSections = flattenCMSSectionLists(props.sections);

  return (
    <Fragment>
      <CustomPageHead title={props.title} seo={props.seo} />
      <StyledTopBox
        linearBackground
        title={props.title}
        background
        breadCrumpPath={props.breadCrumpPath}
        noMargin
      />
      <Navigable>
        <StickyNav
          scrollable={true}
          links={[...extractLinksFromSections(cmsSections)]}
        />
        <SectionListWithNav
          sections={cmsSections}
          noNavRender
          alwaysRenderSideBar
          limitContentWidth
          sidebarLabel="Weitere Links"
          sidebar={() => (
            <>
              <StyledBookmarkButton
                bookmark={{
                  id: props._id,
                  title: props.title,
                  href: props.url
                }}
                activeText="Artikel gemerkt"
              >
                Artikel merken
              </StyledBookmarkButton>
            </>
          )}
        />
      </Navigable>
      {props.pageContents &&
        props.pageContents.items &&
        props.pageContents.items.length > 0 && (
          <FundingStoriesSection
            sectionProps={{ reducedSectionPadding: true, leftIndented: true }}
            items={[]}
          />
        )}
    </Fragment>
  );
}

// NO IMAGAES LOADED ON THESE PAGES SO COMMENTED OUT

// NachhaltigkeitPage.getImages = (props: Props) => {
//   let images = [];
//   const sections = flattenCMSSectionLists(props.sections);
//   if (sections) {
//     images = images.concat(DefaultSectionListWithNav.getImages({ sections }));
//   }
//   return images;
// };
